import { i as l, l as h } from "./core-CongXJuo.js";
var t = [], n = (e) => typeof e == "object" && e !== null && "_addDisposer" in e, y = (e) => (typeof e == "object" || typeof e == "function") && e !== null && typeof e.then == "function", v = (e) => {
  const r = typeof e.constructor == "function" ? e.constructor.name : void 0;
  return typeof e == "function" && (Symbol.toStringTag in e && e[Symbol.toStringTag] === "AsyncFunction" || r === "AsyncFunction");
}, c = () => {
  for (let e = t.length - 1; e >= 0; e--) if (t[e].active) return t[e];
}, d = class {
  constructor() {
    this.disposers = [], this._active = !0;
  }
  get active() {
    return this._active;
  }
  _addDisposer(e) {
    this._active && this.disposers.push(e);
  }
  run(e) {
    if (!this._active) throw new Error("bQuery reactive: Cannot run in a stopped effectScope");
    if (v(e)) throw new Error("bQuery reactive: effectScope.run() only supports synchronous callbacks");
    t.push(this);
    try {
      const r = e();
      if (y(r))
        throw this.stop(), new Error("bQuery reactive: effectScope.run() only supports synchronous callbacks");
      return r;
    } finally {
      t.pop();
    }
  }
  stop() {
    if (this._active) {
      this._active = !1;
      for (let e = this.disposers.length - 1; e >= 0; e--) try {
        this.disposers[e]();
      } catch (r) {
        console.error("bQuery reactive: Error in scope cleanup", r);
      }
      this.disposers.length = 0;
    }
  }
}, b = () => {
  const e = new d(), r = c();
  return n(r) && r._addDisposer(() => e.stop()), e;
}, _ = () => c(), g = (e) => {
  const r = c();
  if (!r || !r.active || !n(r)) throw new Error("bQuery reactive: onScopeDispose() must be called inside an active effectScope");
  r._addDisposer(e);
}, D = (e) => {
  let r, o = !1;
  const a = c(), p = () => {
    if (r) {
      try {
        r();
      } catch (i) {
        console.error("bQuery reactive: Error in effect cleanup", i);
      }
      r = void 0;
    }
  }, f = () => {
    p(), l(s);
  }, u = () => {
    o || (o = !0, f());
  };
  n(a) && a._addDisposer(u);
  const s = () => {
    if (!o) {
      p(), l(s);
      try {
        r = h(s, e);
      } catch (i) {
        console.error("bQuery reactive: Error in effect", i);
      }
      o && f();
    }
  };
  return s(), u;
};
export {
  n as a,
  _ as i,
  b as n,
  g as o,
  c as r,
  D as t
};

//# sourceMappingURL=effect-Cc51IH91.js.map